import { render, staticRenderFns } from "./sggl_1.vue?vue&type=template&id=67e548ca&scoped=true&"
import script from "./sggl_1.vue?vue&type=script&lang=js&"
export * from "./sggl_1.vue?vue&type=script&lang=js&"
import style0 from "./sggl_1.vue?vue&type=style&index=0&id=67e548ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e548ca",
  null
  
)

export default component.exports